import * as React from 'react';
import { Select, MenuItem, Button, Paper, Typography, TextField } from '@mui/material';
import { CSVLink } from 'react-csv';
import jsPDF from 'jspdf';
import 'jspdf-autotable';

const data = [
  {
    id: 1,
    ticketId: "TKT001",
    subject: "This is a sample subject",
    description: "This is a sample description",
    firstName: "John",
    lastName: "Doe",
    email: "johndoe@example.com",
    date: "2022-01-01",
    timeIn: "10:00 AM",
    timeOut: "12:00 PM",
    oldestCall: "11:00 AM",
  },
  {
    id: 2,
    ticketId: "TKT002",
    subject: "This is another sample subject",
    description: "This is another sample description",
    firstName: "Jane",
    lastName: "Doe",
    email: "janedoe@example.com",
    date: "2022-01-02",
    timeIn: "9:00 AM",
    timeOut: "11:00 AM",
    oldestCall: "10:00 AM",
  }
];

export default function DownloadPage() {
  const [selectedFormat, setSelectedFormat] = React.useState('txt');

  const handleFormatChange = (event) => {
    setSelectedFormat(event.target.value);
  };

  const handleDownload = () => {
    if (selectedFormat === 'txt') {
      // generate TXT file
      let fileContent = data.map(d => `${d.id} ${d.ticketId} ${d.subject}`).join('\n');
      let fileBlob = new Blob([fileContent], { type: 'text/plain' });
      let url = URL.createObjectURL(fileBlob);
      let link = document.createElement('a');
      link.href = url;
      link.download = `data.${selectedFormat}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else if (selectedFormat === 'csv') {
      // generate CSV file using react-csv
      let csvData = data.map(d => ({
        id: d.id,
        ticketId: d.ticketId,
        subject: d.subject
      }));
      let csvHeaders = [
        { label: 'ID', key: 'id' },
        { label: 'Ticket ID', key: 'ticketId' },
        { label: 'Subject', key: 'subject' }
      ];
      <CSVLink data={csvData} headers={csvHeaders} filename={`data.${selectedFormat}`}>
        Download
      </CSVLink>
    } else if (selectedFormat === 'pdf') {
      // generate PDF using jspdf
      let doc = new jsPDF();
      doc.autoTable({
        head: [['ID', 'Ticket ID', 'Subject']],
        body: data.map(d => [d.id, d.ticketId, d.subject])
      });
      doc.save(`data.${selectedFormat}`);
    }
  };

  return (
    <div style={{display:'flex',justifyContent:'center',padding:'2rem'}}>
    <div style={{width:'50%'}}>
 <b >Download</b>
    <br/>
    <br/>
    <TextField
      fullWidth
      placeholder='Ticket ID'
    />
    <br/>
    <br/>
    <b>Period</b>
    <Select defaultValue={'week'} fullWidth>
        <MenuItem value="week">This week</MenuItem>
        <MenuItem value="month">This month</MenuItem>
        <MenuItem value="year">This year</MenuItem>
      </Select>
      <br/>
    <br/>
      <Select value={selectedFormat} onChange={handleFormatChange} fullWidth>
        <MenuItem value="txt">TXT</MenuItem>
        <MenuItem value="csv">CSV</MenuItem>
        <MenuItem value="pdf">PDF</MenuItem>
      </Select>
      <br/>
      <br/>
      <Button variant="contained" onClick={handleDownload}>Download</Button>
    </div>
   
    </div>
  );
}
